import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavigationEnd, Router } from "@angular/router";
import { environment } from "../environments/environment";

declare var gtag: Function;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private titleService: Title) {}

  ngOnInit() {
    this.addGoogleAnalytics();
    let isNotProduction = environment.name != "production";
    if (isNotProduction) {
      this.titleService.setTitle("Homologação Evlos | Sistema de Boletagem");
    } else {
      this.titleService.setTitle("Evlos | Sistema de Boletagem");
    }
  }

  addGoogleAnalytics() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag("config", "UA-142698366-1", {
          page_path: event.urlAfterRedirects,
        });
      }
    });
  }
}
